import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

const NotFoundPage = () => {
  useEffect(() => {
    document.title = "Page Not Found | Professional Service Associates";
  }, []);

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-gray-50 py-16">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-9xl font-bold text-psa-green-600 mb-8 font-display">
          404
        </h1>
        <h2 className="text-3xl font-semibold text-gray-900 mb-4">
          Page Not Found
        </h2>
        <p className="text-gray-600 text-lg max-w-md mx-auto mb-10">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 bg-psa-green-600 hover:bg-psa-green-700 text-white font-medium rounded-md transition-colors duration-300"
          >
            <Home size={18} className="mr-2" />
            Back to Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center px-6 py-3 bg-white hover:bg-gray-100 text-psa-green-600 font-medium rounded-md border border-psa-green-600 transition-colors duration-300"
          >
            <ArrowLeft size={18} className="mr-2" />
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
